import * as React from 'react';
import { SelectionContainer, Text } from '@quality24/design-system';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ImprovementsSelector.module.scss';

export interface Props<T extends string | number = string> {
  titles: string[];
  className?: string;
  value: T[];
  onChange: (value: T[]) => void;
}

const ImprovementsSelector = <T extends string | number = string>({
  value,
  onChange,
  titles,
  className = '',
}: React.PropsWithChildren<Props<T>>) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mb-3">
        <Text weight="semiBold">{t('survey.improvements.question')}</Text>
        <Text size="sm2">{t('survey.improvements.subtitle')}</Text>
      </div>
      <SelectionContainer
        mode="vertical"
        className={classNames(styles.wrapper, className)}
        allowMultiple
        value={value}
        onChange={(v) => {
          if (Array.isArray(v)) {
            onChange(v);
          }
        }}
      >
        {titles.map((element) => (
          <SelectionContainer.Option
            key={element}
            value={element}
            className={styles.item}
          >
            <Text weight="semiBold" size="sm2">
              {element}
            </Text>
          </SelectionContainer.Option>
        ))}
      </SelectionContainer>
    </>
  );
};

export default ImprovementsSelector;
